import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e60affd4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "universalRound",
  style: {
    "bottom": "400px",
    "left": "-400px",
    "z-index": "1"
  }
}, null, -1));
const _hoisted_5 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "universalRound",
  style: {
    "bottom": "600px",
    "right": "-800px",
    "z-index": "1",
    "width": "1800px",
    "height": "1600px",
    "background-size": "1800px 1600px"
  }
}, null, -1));
const _hoisted_7 = {
  class: "universalRound-bg",
  style: {
    "background-position": "-150% 0%",
    "background-size": "1800px 1600px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_header_com = _resolveComponent("header-com");
  const _component_module_head_com = _resolveComponent("module-head-com");
  const _component_service_intr = _resolveComponent("service-intr");
  const _component_service_content = _resolveComponent("service-content");
  const _component_advantage_com = _resolveComponent("advantage-com");
  const _component_process_com = _resolveComponent("process-com");
  const _component_recommend_com = _resolveComponent("recommend-com");
  const _component_apply_com = _resolveComponent("apply-com");
  const _component_footer_com = _resolveComponent("footer-com");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_header_com), _createVNode(_component_module_head_com, {
    title: "开发安全SDL咨询",
    tips: "定制化的安全开发体系建设",
    buttomName: "项目咨询",
    ngUrl: _ctx.BG
  }, null, 8, ["ngUrl"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_service_intr), _createElementVNode("div", _hoisted_3, [_createVNode(_component_service_content, {
    ref: "ServiceContent"
  }, null, 512), _hoisted_4]), _createVNode(_component_advantage_com, {
    ref: "AdvantageCom"
  }, null, 512), _createElementVNode("div", _hoisted_5, [_createVNode(_component_process_com, {
    ref: "ProcessCom"
  }, null, 512), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_recommend_com, {
    ref: "RecommendCom"
  }, null, 512)])]), _createVNode(_component_apply_com, {
    ref: "ApplyCom"
  }, null, 512), _createVNode(_component_footer_com)]);
}